/**
 * Bay name for the lesson flow — [BUT-843, ours].
 *
 * Resolves against `club.bays`, the same source `PaymentDetailsStep` uses.
 * No session-storage fallback (tech lead ruling 8): a bay not on the roster
 * falls straight to `Bay {id}`.
 *
 * @module pages/lessons/lessonBayName
 */

import type { Bay } from '@lgc/database/types';

export function resolveLessonBayName(clubBays: Bay[] | undefined, bayId: number): string {
  return clubBays?.find((bay) => bay.id === bayId)?.name ?? `Bay ${bayId}`;
}
